import axios from "axios";
import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

const url = "";
const searchTlc = "/api/business/decision-detailed-fluctuations";
const searchCodeType = "/api/business/tlc-code-types";
export default class FeeCodeDetailCpnService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public getSearchReceipt(querySearch): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(url + "/api/tlc-cpn-code/cpn-code-detail-fee-report?" + this.convertObjectParamToStrings.convertObjectParamToStrings(querySearch))
        .then((res) => {
          console.log(12321);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getAllTlcCodeTypes(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(url + searchCodeType)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch(() => {});
    });
  }
}
